import { useMemo } from 'react';

import { useAppStore } from '../../../store/useAppStore';
import { DEFAULT_ROLES, getRoleById } from '../../auth/permissions';
import { Permission } from '../../auth/types';
import {
    filterScriptGatedTools,
    getAccessibleTools,
    type ToolId,
} from '../../layout/workspace-config';

export function useDashboardAccessibleToolIds(): Set<ToolId> {
    const user = useAppStore(state => state.auth.user);
    const cloudEnabled = useAppStore(state => state.cloud.enabled);
    const cloudMember = useAppStore(state => state.cloud.member);
    const roles = useAppStore(state => state.admin.roles);
    const scriptTextAccess = useAppStore(state => state.cloud.scriptTextAccess ?? false);

    return useMemo(() => {
        const effectiveRoles = roles.length > 0 ? roles : DEFAULT_ROLES;
        const userRole = cloudMember
            ? getRoleById(effectiveRoles, cloudMember.roleId)
            : null;
        const userPermissions = user?.isSuperAdmin || !cloudEnabled
            ? Object.values(Permission)
            : userRole?.permissions ?? [];

        return new Set(
            filterScriptGatedTools(
                getAccessibleTools(userPermissions),
                scriptTextAccess
            ).map(tool => tool.id)
        );
    }, [cloudEnabled, cloudMember, roles, scriptTextAccess, user?.isSuperAdmin]);
}
